import { fetchAuthSession } from "aws-amplify/auth";
import { OpenAPI } from "./generated";
import { getRuntimeAppConfig } from "../config/runtimeAppConfig";

export const configureOpenApi = async () => {
  const runtimeConfig = await getRuntimeAppConfig();
  OpenAPI.BASE =
    runtimeConfig.apiBaseUrl ?? import.meta.env.VITE_API_BASE_URL ?? "";

  OpenAPI.TOKEN = async () => {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.accessToken?.toString() ?? "";
    } catch {
      return "";
    }
  };
};
